module.exports = __webpack_public_path__ + "img/dataflare_og.57c97af0.png";